import {Button} from '@albert-io/atomic';
import withTracking from 'lib/hocs/withTracking';
import {getNodeText} from 'lib/reactUtils';

const TrackedButton = withTracking(Button, {
  onClick: {content: (e, props, ref) => getNodeText(ref), event: 'click', type: 'button'}
});

export default TrackedButton;
